import React from 'react'
// import VideoPlayer from '../helper/VideoPlayer';

export default () => {
  return (
    <div> 
        <h2>This type of dizziness is usually caused by  <strong className="text-decoration" data-tip="Episodes of dizziness, motion sensitivity, and/or nausea that may or may not be accompanied by a headache">Meniere's Disease (MD)</strong> </h2>
        <p>Now that we have a good idea of what might be going on, we can help direct you to some resources!</p>
        <p>To receive an official diagnosis and find out the best treatment for your needs, be sure to visit a healthcare provider.</p>
        <a id="Menieres" href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>       
    </div>

    
  )
}
